import CAApi from './_caApi';

class CAReceiptDetailTaxAPI extends CAApi {
  constructor() {
    super();
  }
  controllerName = 'CAReceiptDetailTaxs';
}

export default new CAReceiptDetailTaxAPI();
